import React, { FC, useEffect, useLayoutEffect, useRef, useState } from 'react';
import './style.scss';
import Icon from 'components/Utils/NewIcon';
import UnreadBadge from 'components/Common/UnreadBadge';

interface SmoothCollapseProps {
  icon?: string;
  title?: string;
  open?: boolean;
  count?: number;
  children?: JSX.Element;
}

const SmoothCollapse: FC<SmoothCollapseProps> = ({ icon, title, open = true, children, count }) => {
  const [isOpen, setOpen] = useState(open ?? false);
  const contentDiv = useRef<HTMLDivElement>(null);
  const height = useRef(0);

  function animateClose() {
    const style = contentDiv.current?.style;

    if (style) {
      style.height = '0px';
      style.paddingBottom = '0px';
    }
  }

  function animateOpen() {
    const style = contentDiv.current?.style;

    if (style) {
      style.height = `${height.current}px`;
      style.paddingBottom = '';
    }
  }

  useLayoutEffect(() => {
    height.current = contentDiv.current?.clientHeight ?? 0;
    if (open) {
      animateOpen();
    } else {
      animateClose();
    }
  }, []);

  useEffect(() => {
    if (contentDiv.current == null) {
      return;
    }
    if (isOpen) {
      animateOpen();
    } else {
      animateClose();
    }
  }, [isOpen]);

  let className = 'smooth-collapse';
  if (isOpen) {
    className += ' is-open';
  }

  return (
    <div className={className}>
      <div className="smooth-collapse__header" onClick={() => setOpen(!isOpen)}>
        {icon && <Icon src={icon} className="left-icon" height="25px" width="25px" />}
        {title && (
          <div className="title">
            <span>{title}</span>
            {!isOpen && count && count > 0 ? <UnreadBadge unreadCount={count} /> : null}
          </div>
        )}
        <Icon src={['far', 'chevron-right']} height="16px" width="16px" className="icon-chevron" />
      </div>

      <div ref={contentDiv} className="content">
        {children}
      </div>
    </div>
  );
};

export default SmoothCollapse;
